export default "__VITE_ASSET__Dcd9TnMt__"